var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.d{fill:none;}.b{stroke:#fff;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-282 -1278)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-537 908.741)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-3.224-10.859a4.344,4.344,0,0,1,.5-.36,3.915,3.915,0,0,1,.581-.3,3.636,3.636,0,0,1,.668-.2A3.944,3.944,0,0,1-.7-11.784a3.339,3.339,0,0,1,1.053.155,2.28,2.28,0,0,1,.8.444,1.947,1.947,0,0,1,.506.7,2.242,2.242,0,0,1,.177.9,2.3,2.3,0,0,1-.13.82,2.236,2.236,0,0,1-.332.6,2.518,2.518,0,0,1-.441.438l-.453.345A3.8,3.8,0,0,0,.1-7.07a.658.658,0,0,0-.2.348l-.174.87H-1.584l-.137-1q-.006-.037-.009-.075t0-.075A.871.871,0,0,1-1.6-7.48a1.7,1.7,0,0,1,.329-.376,5.077,5.077,0,0,1,.429-.329,3.877,3.877,0,0,0,.429-.342,1.727,1.727,0,0,0,.329-.41,1.059,1.059,0,0,0,.13-.537A.758.758,0,0,0-.2-10.067a.972.972,0,0,0-.674-.22,1.884,1.884,0,0,0-.55.068,2.215,2.215,0,0,0-.379.152q-.158.084-.276.152a.467.467,0,0,1-.236.068.428.428,0,0,1-.4-.23ZM-2.081-3.61A1.031,1.031,0,0,1-2-4.027a1.052,1.052,0,0,1,.23-.335,1.1,1.1,0,0,1,.345-.227,1.107,1.107,0,0,1,.435-.084,1.091,1.091,0,0,1,.429.084,1.135,1.135,0,0,1,.348.227,1.028,1.028,0,0,1,.233.335,1.031,1.031,0,0,1,.084.416,1.053,1.053,0,0,1-.084.419,1.02,1.02,0,0,1-.233.338,1.09,1.09,0,0,1-.348.224,1.128,1.128,0,0,1-.429.081,1.144,1.144,0,0,1-.435-.081,1.054,1.054,0,0,1-.345-.224A1.043,1.043,0,0,1-2-3.191,1.053,1.053,0,0,1-2.081-3.61Z",
    transform: "translate(827.352 383.922)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(282 1278)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 7.5,
    cy: 7.5,
    r: 7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkWhite);
export default __webpack_public_path__ + "static/media/question-mark-white.15955f0c7da594b173048ce0557467c3.svg";
export { ForwardRef as ReactComponent };